import Form from './form'
import Root from './root'
import LoadingPage from './loading-page'

/**
 * Default export.
 *
 * @param Vue
 */
export default (Vue) => {
  Form(Vue)
  Root(Vue)
  LoadingPage(Vue)
}



// WEBPACK FOOTER //
// ./src/components/index.js